import { networkFromApi } from '../network';
import type {
  NetworkAuthenticationApiResponse,
  NetworkAuthenticationBase,
  NetworkAuthenticationBaseApiResponse,
  NetworkLog,
  NetworkRegistrationApiResponse,
  NetworkRegistrationBase,
  NetworkRegistrationBaseApiResponse,
  SimEventApiResponse,
  SimEventBase,
  SimEventBaseApiResponse,
} from './types';

export * from './types';

function parseNetworkRegistration(networkRegistration: NetworkRegistrationBaseApiResponse): NetworkRegistrationBase {
  return {
    id: networkRegistration.id,
    type: networkRegistration.type,
    time: networkRegistration.time,
    simId: networkRegistration.sim_id,
    iccid: networkRegistration.iccid,
    imei: networkRegistration.imei,
    imeiLock: networkRegistration.imeiLock,
    networkType: networkRegistration.network_type,
    countryCode: networkRegistration.country_code,
    network: networkFromApi(networkRegistration.network),
    isDataAttach: networkRegistration.is_data_attach,
    sessionBytes: networkRegistration.session_bytes,
  };
}

function parseNetworkAuthentication(
  networkAuthentication: NetworkAuthenticationBaseApiResponse,
): NetworkAuthenticationBase {
  return {
    id: networkAuthentication.id,
    time: networkAuthentication.time,
    simId: networkAuthentication.sim_id,
    iccid: networkAuthentication.iccid,
    imei: networkAuthentication.imei,
    imeiLock: networkAuthentication.imeiLock,
    countryCode: networkAuthentication.country_code,
    network: networkFromApi(networkAuthentication.network),
    reason: networkAuthentication.reason,
    status: networkAuthentication.status,
    networkType: networkAuthentication.network_type,
  };
}
function parseSimEvent(simEvent: SimEventBaseApiResponse): SimEventBase {
  let meta = simEvent.meta;
  if (typeof meta === 'string') {
    try {
      meta = JSON.parse(meta);
    } catch {
      // noop
    }
  }

  return {
    id: `${simEvent.sim_id}-${simEvent.time}-${simEvent.event}`,
    time: simEvent.time,
    simId: simEvent.sim_id,
    event: simEvent.event,
    meta,
  };
}

export function fromApi(
  doc: NetworkRegistrationApiResponse | NetworkAuthenticationApiResponse | SimEventApiResponse,
): NetworkLog | undefined {
  if (doc.log_type === 'network-registration') {
    return {
      ...parseNetworkRegistration(doc),
      logType: doc.log_type,
    };
  }
  if (doc.log_type === 'network-authentication') {
    return {
      ...parseNetworkAuthentication(doc),
      logType: doc.log_type,
    };
  }
  if (doc.log_type === 'sim-event') {
    return {
      ...parseSimEvent(doc),
      logType: doc.log_type,
    };
  }
  console.warn('Unknown log_type found for network log:', (doc as { log_type: string }).log_type);
}
